package org.example.project.engineletter.layouts

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.attributes.InputType

@Composable
fun VollmachtSysLayout(
    rootElementId: String? = null,
    eigeneDatenZeile: String,
    empfaengerFirmenname: String,
    empfaengerStrasseHausnummer: String,
    empfaengerPlzOrt: String,
    absenderFirmenName: String,
    absenderStrasseHausnummer: String,
    absenderPlzOrt: String,
    absenderDatum: String,
    betreffText: String,
    briefText: String,
    headerMode: String,
    footerMode: String,
    grussformelText: String,
    ortDatumText: String,
    logoSrc: String,
    footerLines: List<String>,
    vollmachtgeberSignatur: String,
    vollmachtgeberName: String,
    bevollmaechtigteName: String,
    bevollmaechtigteSignatur: String,
    editable: Boolean,
    onEmpfaengerFirmennameChange: (String) -> Unit,
    onEmpfaengerStrasseHausnummerChange: (String) -> Unit,
    onEmpfaengerPlzOrtChange: (String) -> Unit,
    onAbsenderFirmenNameChange: (String) -> Unit,
    onAbsenderStrasseHausnummerChange: (String) -> Unit,
    onAbsenderPlzOrtChange: (String) -> Unit,
    onAbsenderDatumChange: (String) -> Unit,
    onBetreffChange: (String) -> Unit,
    onTextChange: (String) -> Unit,
    onGrussformelChange: (String) -> Unit,
    onSignaturOrtDatumChange: (String) -> Unit,
    onSignaturNameChange: (String) -> Unit,
    onFooterLineChange: (Int, String) -> Unit,
    onBevollmaechtigteNameChange: (String) -> Unit
) {
    LetterBriefSysLayout(
        rootElementId = rootElementId,
        eigeneDatenZeile = eigeneDatenZeile,
        empfaengerFirmenname = empfaengerFirmenname,
        empfaengerStrasseHausnummer = empfaengerStrasseHausnummer,
        empfaengerPlzOrt = empfaengerPlzOrt,
        absenderFirmenName = absenderFirmenName,
        absenderStrasseHausnummer = absenderStrasseHausnummer,
        absenderPlzOrt = absenderPlzOrt,
        absenderDatum = absenderDatum,
        betreffText = betreffText,
        briefText = briefText,
        headerMode = headerMode,
        footerMode = footerMode,
        grussformelText = grussformelText,
        ortDatumText = ortDatumText,
        logoSrc = logoSrc,
        footerLines = footerLines,
        signaturBildSrc = vollmachtgeberSignatur,
        signaturNameText = vollmachtgeberName,
        editable = editable,
        onEmpfaengerFirmennameChange = onEmpfaengerFirmennameChange,
        onEmpfaengerStrasseHausnummerChange = onEmpfaengerStrasseHausnummerChange,
        onEmpfaengerPlzOrtChange = onEmpfaengerPlzOrtChange,
        onAbsenderFirmenNameChange = onAbsenderFirmenNameChange,
        onAbsenderStrasseHausnummerChange = onAbsenderStrasseHausnummerChange,
        onAbsenderPlzOrtChange = onAbsenderPlzOrtChange,
        onAbsenderDatumChange = onAbsenderDatumChange,
        onBetreffChange = onBetreffChange,
        onTextChange = onTextChange,
        onGrussformelChange = onGrussformelChange,
        onSignaturOrtDatumChange = onSignaturOrtDatumChange,
        onSignaturNameChange = onSignaturNameChange,
        onFooterLineChange = onFooterLineChange,
        closingBlockLines = 7,
        closingContent = {
            VollmachtSignatureClosing(
                ortDatumText, vollmachtgeberSignatur, vollmachtgeberName,
                bevollmaechtigteName, bevollmaechtigteSignatur, editable,
                onBevollmaechtigteNameChange
            )
        }
    )
}

@Composable
private fun VollmachtSignatureClosing(
    ortDatum: String,
    ausstellerSignatur: String,
    ausstellerName: String,
    bevollmaechtigteName: String,
    bevollmaechtigteSignatur: String,
    editable: Boolean,
    onNameChange: (String) -> Unit
) {
    Div({ style { marginTop(8.px); marginBottom(10.px); display(DisplayStyle.Grid); property("grid-template-columns", "1fr 1fr"); gap(42.px); flexShrink(0) } }) {
        VollmachtSignatureColumn("Vollmachtgeber", ortDatum, ausstellerName, ausstellerSignatur, false, {})
        VollmachtSignatureColumn("Bevollmächtigte Person", ortDatum, bevollmaechtigteName, bevollmaechtigteSignatur, editable, onNameChange)
    }
}

@Composable
private fun VollmachtSignatureColumn(label: String, ortDatum: String, name: String, signatur: String, editable: Boolean, onNameChange: (String) -> Unit) {
    Div({ style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); fontSize(13.px) } }) {
        Div({ style { fontWeight("700") } }) { Text(label) }
        Div({ style { marginTop(12.px) } }) { Text(ortDatum.ifBlank { " " }) }
        Div({ style { height(72.px); display(DisplayStyle.Flex); alignItems(AlignItems.FlexEnd) } }) {
            if (signatur.startsWith("data:image/")) Img(src = signatur, attrs = { style { maxWidth(210.px); maxHeight(56.px); property("object-fit", "contain") } })
        }
        Div({ style { property("border-top", "1px solid #333"); height(5.px) } })
        if (editable) Input(InputType.Text, attrs = { value(name); onInput { onNameChange(it.value) }; attr("placeholder", "Name"); style { border(0.px); padding(2.px, 0.px); fontSize(13.px) } })
        else Div({ style { paddingTop(2.px); minHeight(18.px) } }) { Text(name) }
    }
}
